import { getAppConfiguration } from "../../../Config";
import { interceptFetch } from "../../InterceptFetch";
import { AuthHeaders } from "../Component/authHeader";
import { ALL_GROUP_USER, ASSIGN_USER_GROUP, CREATE_GROUP, CUSTOMER, FTP_PROCESS_URL, FTP_USER, GET_GROUP_BYID, USER_GROUP, USER_GROUP_DELETE, USER_GROUPS } from "../Component/EndPointServices";
const mlsApiLocal = getAppConfiguration().mlsApiUrl;
class UserGroupHelperServices {
    CREATE_USERS_GROUP = async(groupParam:any,customerId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(groupParam),headers: headers};
        try{
        const createGroup =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId+USER_GROUP,options).catch(err=>{console.log("the error user group  ==>",err)});
        return createGroup;
        }catch(error){console.log(error,"user group error helper")}
    };
    UPDATE_USERS_GROUP = async(groupParam:any,userGroupId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "PUT",body:JSON.stringify(groupParam),headers: headers};
        try{
        const updateGroup =  await interceptFetch(mlsApiLocal+CREATE_GROUP+userGroupId,options).catch(err=>{console.log("the error update user group  ==>",err)});
        return updateGroup;
        }catch(error){console.log(error,"update user group error helper")}
    };
    ALL_USERS_GROUP = async(customerId, accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const allUsersGroup =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId+USER_GROUPS,options).catch(err=>{console.log("the error all user group  ==>",err)});
        return allUsersGroup;
        }catch(error){console.log(error,"users group error helper")}
    };
    DELETE_USERS_GROUP = async(userGroupId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
        try{
        const deleteGroup =  await interceptFetch(mlsApiLocal+USER_GROUP_DELETE+userGroupId,options).catch(err=>{console.log("the delete error user group  ==>",err)});
        return deleteGroup;
        }catch(error){console.log(error,"delete user group error helper")}
    };
    GET_ID_BY_USERS_GROUP = async(userId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const getIdBy =  await interceptFetch(mlsApiLocal+GET_GROUP_BYID+userId,options).catch(err=>{console.log("the error get by id user group  ==>",err)});
        return getIdBy;
        }catch(error){console.log(error,"get by id user group error helper")}
    };
    ASSIGN_GROUP_ADD_USER = async(userGroup:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "PUT",body:JSON.stringify(userGroup),headers: headers};
        try{
        const formGroupAdd =  await interceptFetch(mlsApiLocal+ASSIGN_USER_GROUP,options).catch(err=>{console.log("the error form user group  ==>",err)});
        return formGroupAdd;
        }catch(error){console.log(error,"form user group  error helper")}
    };
    PROCESS_FTP = async(userId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const ftpProcess =  await fetch(mlsApiLocal+FTP_USER+userId+FTP_PROCESS_URL,options).then(response =>{ 
        return response.text()}).catch(err=>{console.log("the error ftp process helper  ==>",err.response)});
        return ftpProcess;
        }catch(error){console.log(error,"ftp process error helper")}
    };
}
export default new UserGroupHelperServices();